import { Layout } from "antd";
import { useTranslation } from "react-i18next";

import BaseHeader from "@/components/Header/BaseHeader";
import UserHeaderButtons from "@/components/Header/User";
import { TAB_KEYS } from "@/constants/TabKeys";
import { useGetUser, USER_INCLUDES } from "@/entities/user";
import { PageItemGate } from "@/modules/page-item-gate";
import { useIdParam } from "@/services/router";
import { ContextTabs } from "@/ui/context-tabs";

import TabInterventions from "./TabInterventions";
import TabRoleAndPermissions from "./TabRolesAndPermissions";

const { Content } = Layout;

const UserDetails = () => {
  const id = useIdParam();
  const { t } = useTranslation();

  const include = [USER_INCLUDES.ORGANIZATION, USER_INCLUDES.ROLES];

  const { isLoading, user, error } = useGetUser(id, {
    params: { include: include.join(",") },
  });

  const tabs = [
    {
      key: TAB_KEYS.USERS_INTERVENTIONS,
      label: t("global:interventionPlural"),
      children: <TabInterventions userId={id} />,
    },
    {
      key: TAB_KEYS.USERS_ROLES,
      label: `${t("user:rolePlural")} ${t("global:and")} ${t(
        "user:permissionPlural"
      )}`,
      children: <TabRoleAndPermissions user={user} loading={isLoading} />,
    },
  ];

  return (
    <PageItemGate model="user" queryError={error}>
      <BaseHeader
        title={user?.name}
        loading={isLoading}
        extra={
          !isLoading && [
            <UserHeaderButtons key="UserHeaderButtons" user={user} />,
          ]
        }
      />
      <Content>
        <ContextTabs defaultActiveKey="interventions" items={tabs} />
      </Content>
    </PageItemGate>
  );
};

export default UserDetails;
